export default [
  {
    "id": 1,
    "data": {
      "subject_id": 444,
      "subject_type": "kanji",
      "srs_stage": 0,
    }
  },
  {
    "id": 2,
    "data": {
      "subject_id": 453,
      "subject_type": "kanji",
      "srs_stage": 1,
    }
  },
  {
    "id": 3,
    "data": {
      "subject_id": 455,
      "subject_type": "kanji",
      "srs_stage": 2,
    }
  },
  {
    "id": 4,
    "data": {
      "subject_id": 2502,
      "subject_type": "vocabulary",
      "srs_stage": 4,
    }
  },
  {
    "id": 5,
    "data": {
      "subject_id": 2503,
      "subject_type": "vocabulary",
      "srs_stage": 6,
    }
  },
  {
    "id": 6,
    "data": {
      "subject_id": 2504,
      "subject_type": "vocabulary",
      "srs_stage": 7,
    }
  },
  {
    "id": 7,
    "data": {
      "subject_id": 7560,
      "subject_type": "vocabulary",
      "srs_stage": 8,
    }
  },
  {
    "id": 8,
    "data": {
      "subject_id": 8761,
      "subject_type": "radical",
      "srs_stage": 1,
    }
  },
  {
    "id": 9,
    "data": {
      "subject_id": 8762,
      "subject_type": "radical",
      "srs_stage": 1,
    }
  },
  {
    "id": 10,
    "data": {
      "subject_id": 8763,
      "subject_type": "radical",
      "srs_stage": 4,
    }
  },
];
